import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAsset5 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.75 4.75H6.75V9.05232M0.75 9.05232H3.75H6.75M6.75 9.05232V14.75M14.75 0.75H0.75V14.75H14.75V0.75Z",
		stroke: "#212121",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgAsset5;
